module.exports = __webpack_public_path__ + "static/media/expert1.f541ea4e.png";